import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Components
import MyButton from '../../utils/MyButton';

// Redux
import { connect } from 'react-redux';
import { likeScream, unlikeScream } from '../../redux/actions/dataActions';
import CircularProgress from '@mui/material/CircularProgress';

//Icons
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';


class LikedButton extends Component {

    state = {
        loading: false
    };

    likedScream = () => {
        if (this.props.user.likes &&
            this.props.user.likes.find(
                like => like.screamId === this.props.screamId
            )
        )
            return true
        else return false
    };

    likeScream = () => {
        this.setState({ loading: true });
        this.props.likeScream(this.props.screamId)
            .finally(() => this.setState({ loading: false }));
    }

    unlikeScream = () => {
        this.setState({ loading: true });
        this.props.unlikeScream(this.props.screamId)
            .finally(() => this.setState({ loading: false }));
    }

    render() {

        const { user: { authenticated } } = this.props;
        const { loading } = this.state;

        if (loading) {
            return (
                <MyButton tip="Loading" disabled>
                    <CircularProgress size={22} thickness={4} />
                </MyButton>
            );
        }

        const likeButton = !authenticated
            ? (
                <Link to="/login">
                    <MyButton tip="Like">
                        <FavoriteBorder color="primary" />
                    </MyButton>
                </Link>
            )
            : (
                this.likedScream()
                    ? (
                        <MyButton tip="Undo Like" onClick={this.unlikeScream}>
                            <Favorite color="primary" />
                        </MyButton>
                    )
                    : (
                        <MyButton tip="Like" onClick={this.likeScream}>
                            <FavoriteBorder color="primary" />
                        </MyButton>
                    )
            )

        return likeButton;
    }
}


LikedButton.propTypes = {
    likeScream: PropTypes.func.isRequired,
    unlikeScream: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    screamId: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
    user: state.user
});

const mapActionToProps = { likeScream, unlikeScream };

export default connect(mapStateToProps, mapActionToProps)(LikedButton)
